import React from "react";
import {
  ButtonEdit,
  EditElementClick,
  ButtonDelete,
  ButtonSmall,
} from "../../common/Buttons";
import { IconDownload } from "../../Layout/Icons";
import moment from "moment";
import { GoPrimitiveDot } from "react-icons/go";
import { exportDocument } from "../../../helpers/Utils";

function TableColumnManagers({ id, item, index, onAction, onDelete }) {
  return (
    <tr className="align-middle tableColumn" key={index}>
      <td className="align-middle  text-center">
        <GoPrimitiveDot
          style={item.exported == true ? { color: "green" } : { color: "red" }}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", id)}
          name={item.supplier_name}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", id)}
          name={item.company}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", id)}
          name={item.invoice_number}
        />
      </td>
      <td className="align-middle ">
        <EditElementClick
          onEdit={() => onAction("edit", id)}
          name={moment(item.invoice_date).format("YYYY-MM-DD")}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", id)}
          name={moment(item.pay_due_date).format("YYYY-MM-DD")}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", id)}
          name={item.items_quantity}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", id)}
          name={item.price_without_pvm}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", id)}
          name={item.pvm}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", id)}
          name={item.discount}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", id)}
          name={item.transport_price}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", id)}
          name={item.price_total}
        />
      </td>
      <td className="align-middle" style={{ width: "50px" }}>
        {item.suppliers_invoices_document_id &&
          <ButtonSmall
            type="outline"
            onClick={() => {
              exportDocument(
                `/api/v1/suppliers_invoices/${id}/download`,
                `${item.invoice_number}.pdf`,
                "GET"
              );
            }}
          >
            <IconDownload color="#007BFF" />
          </ButtonSmall>
        }
      </td>
      <td className="align-middle" style={{ width: "50px" }}>
        <ButtonEdit onEdit={() => onAction("edit", id)} />
      </td>
      <td className="align-middle" style={{ width: "50px" }}>
        <ButtonDelete onDelete={() => onDelete(id)} />
      </td>
    </tr>
  );
}

export default TableColumnManagers;